import React, {Component} from 'react';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import './Loading.css';

export default class Loading extends Component {
    constructor(...props) {
        // noinspection JSCheckFunctionSignatures
        super(...props);
        // 性能优化向
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);

    }

    render() {
        return (
            <div className={"icoDisplay"} style={{display: this.props.loadInfo.display}}>
                <div className="loading"/>
            </div>
        )
    }

    componentDidMount() {

    }

}




// WEBPACK FOOTER //
// ./src/components/loading/Loading.js